import { MediasPublicModels } from '@features/products/medias';
import { ProductPublicFunctions } from '@features/products/product';

const regexHls = /m3u8/i;
const regexMp4 = /mp4/i;

export function getVideoForProductViewUseCase({
    color,
    productImagesLocation,
    locationDefault,
    defaultImageType,
    options,
}): MediasPublicModels.PublicMediaResolved {
    let productVideos: MediasPublicModels.PublicMediaResolved[] = ProductPublicFunctions.GetImagesForColor(
        color,
        productImagesLocation,
        { clazzType: 'video' }
    ) ?? [];

    if (!options.discardDoubleVideo) {
        const productVideosDouble = ProductPublicFunctions.GetImagesForColor(
            color,
            productImagesLocation,
            { clazzType: 'videoDouble' }
        ) ?? [];
        productVideos = productVideos.concat(productVideosDouble);
    }

    let video: MediasPublicModels.PublicMediaResolved = productVideos[0];

    if (defaultImageType) {
        const videoDefaultType = ProductPublicFunctions.GetImagesForColor(color, locationDefault, { clazzType: 'video' })
            .find((vid) => vid.path.includes(defaultImageType) || vid.idMedia === defaultImageType);
        const videoDefaultTypeDouble = ProductPublicFunctions.GetImagesForColor(color, locationDefault, { clazzType: 'videoDouble' })
            .find((vid) => vid.path.includes(defaultImageType) || vid.idMedia === defaultImageType);

        if (videoDefaultType || videoDefaultTypeDouble) {
            video = videoDefaultType || videoDefaultTypeDouble;
        }
    }

    if (!video) {
        video = ProductPublicFunctions.GetImagesForColor(
            color,
            locationDefault,
            { clazzType: 'video' }
        )?.[0];
    }

    return video;
}

export function generateVideoPosterImageUseCase({
    video,
    image,
    discardVideos,
}) {
    if (!video || discardVideos) {
        return { video: null, image };
    }

    let imageVideoPoster: string;
    if (video.path && !video.poster) {
        if (regexHls.test(video.path)) {
            imageVideoPoster = video.path.replace(regexHls, 'jpg');
        } else if (regexMp4.test(video.path)) {
            imageVideoPoster = video.path.replace(regexMp4, 'jpg');
        }
    } else {
        imageVideoPoster = video.poster;
    }

    return {
        video,
        image: {
            ...image,
            path: imageVideoPoster ?? image?.path,
        },
    };
}
